export const visit = (vm, at) => {
vm(require("./availability/es-mx.lyaml"));
vm(require("./typical-response-time/es-mx.lyaml"));
vm(require("./default/es-mx.lyaml"));
at({ "es-mx": { "conversations-internal-schema": { "we-wont-use-this-key-in-the-product-but-this-file-wont-update-with-new-languages-without-a-key": "De acuerdo" } } });
};